import { render, staticRenderFns } from "./BrowseCatalogueHostingInstitutions.vue?vue&type=template&id=1dbc6304"
import script from "./BrowseCatalogueHostingInstitutions.vue?vue&type=script&lang=js"
export * from "./BrowseCatalogueHostingInstitutions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports